/**
 * library documentation here https://github.com/faisalman/ua-parser-js/
 */
import { UAParser } from "ua-parser-js";
export default {
  data() {
    return {
      device_info: {
        ua: "",
        browser: {},
        cpu: {},
        device: {},
        engine: {},
        os: {},
      },
    };
  },
  computed: {
    isWindowsOs() {
      return this.device_info.os.name === "Windows";
    },
    isMacOs() {
      return this.device_info.os.name === "Mac OS";
    },
    isTouchDevice() {
      return ["mobile", "tablet"].includes(this.device_info.device.type);
    },
    isTouchDeviceMobile() {
      return this.device_info.device.type === "mobile";
    },
    isTouchDeviceTablet() {
      return this.device_info.device.type === "tablet";
    },
    /**
     * We can't certainly detect PC due to library limitations (see the note below from lib doc), so possibly every undetected result is PC.
     *
     * ##########
     * # NOTE: 'desktop' is not a possible device type.
     * # UAParser only reports info directly available from the UA string, which is not the case for 'desktop' device type.
     * # If you wish to detect desktop devices, you must handle the needed logic yourself.
     * # You can read more about it in this issue: https://github.com/faisalman/ua-parser-js/issues/182
     * ##########
     * @return {boolean}
     */
    isPcDevice() {
      return !this.device_info.device.type;
    },
  },
  mounted() {
    this.ua = new UAParser();
    this.device_info = this.ua.getResult();
  },
};
